import getFixedPeriodSchemesRef from './getFixedPeriodSchemesRef';
import getFixedPeriodIntervalsRef from './getFixedPeriodIntervalsRef';

const fixedPeriods = {
  getFixedPeriodSchemesRef,
  getFixedPeriodIntervalsRef,
};

export default fixedPeriods;
